import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import dayjsImport from "./auth-service-tools36.js";
import { useDatesContext } from "./auth-service-tools577.js";
import { Day } from "./auth-service-tools579.js";
import { WeekdaysRow } from "./auth-service-tools581.js";
import { getDateInTabOrder } from "./auth-service-tools589.js";
import { getMonthDays } from "./auth-service-tools586.js";
import { isAfterMinDate } from "./auth-service-tools590.js";
import { isBeforeMaxDate } from "./auth-service-tools591.js";
import { isSameMonth } from "./auth-service-tools587.js";
import classes from "./auth-service-tools592.js";
import { factory } from "./auth-service-tools248.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { useResolvedStylesApi } from "./auth-service-tools195.js";
import { Box } from "./auth-service-tools244.js";
const defaultProps = {
  withCellSpacing: true
};
const Month = factory((_props, ref) => {
  const props = useProps("Month", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    __staticSelector,
    locale,
    firstDayOfWeek,
    weekdayFormat,
    month,
    weekendDays,
    getDayProps,
    excludeDate,
    minDate,
    maxDate,
    renderDay,
    hideOutsideDates,
    hideWeekdays,
    getDayAriaLabel,
    static: isStatic,
    __getDayRef,
    __onDayKeyDown,
    __onDayClick,
    __onDayMouseEnter,
    __preventFocus,
    __stopPropagation,
    withCellSpacing,
    size,
    highlightToday,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "Month",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    rootSelector: "month"
  });
  const ctx = useDatesContext();
  const dates = getMonthDays({
    month,
    firstDayOfWeek: ctx.getFirstDayOfWeek(firstDayOfWeek),
    consistentWeeks: ctx.consistentWeeks
  });
  const dateInTabOrder = getDateInTabOrder(dates, minDate, maxDate, getDayProps, excludeDate, hideOutsideDates, month);
  const {
    resolvedClassNames,
    resolvedStyles
  } = useResolvedStylesApi({
    classNames,
    styles,
    props
  });
  const rows = dates.map((row, rowIndex) => {
    const cells = row.map((date, cellIndex) => {
      const outside = !isSameMonth(date, month);
      const ariaLabel = (getDayAriaLabel == null ? void 0 : getDayAriaLabel(date)) || dayjsImport(date).locale(locale || ctx.locale).format("D MMMM YYYY");
      const dayProps = getDayProps == null ? void 0 : getDayProps(date);
      const isDateInTabOrder = dayjsImport(date).isSame(dateInTabOrder, "date");
      return /* @__PURE__ */jsxRuntimeExports.jsx("td", { ...getStyles("monthCell"),
        "data-with-spacing": withCellSpacing || void 0,
        children: /* @__PURE__ */jsxRuntimeExports.jsx(Day, {
          __staticSelector: __staticSelector || "Month",
          classNames: resolvedClassNames,
          styles: resolvedStyles,
          unstyled,
          "data-mantine-stop-propagation": __stopPropagation || void 0,
          highlightToday,
          renderDay,
          date,
          size,
          weekend: ctx.getWeekendDays(weekendDays).includes(date.getDay()),
          outside,
          hidden: hideOutsideDates ? outside : false,
          "aria-label": ariaLabel,
          static: isStatic,
          disabled: (excludeDate == null ? void 0 : excludeDate(date)) || !isBeforeMaxDate(date, maxDate) || !isAfterMinDate(date, minDate),
          ref: node => __getDayRef == null ? void 0 : __getDayRef(rowIndex, cellIndex, node),
          ...dayProps,
          onKeyDown: event => {
            var _a;

            (_a = dayProps == null ? void 0 : dayProps.onKeyDown) == null ? void 0 : _a.call(dayProps, event);
            __onDayKeyDown == null ? void 0 : __onDayKeyDown(event, {
              rowIndex,
              cellIndex,
              date
            });
          },
          onMouseEnter: event => {
            var _a;

            (_a = dayProps == null ? void 0 : dayProps.onMouseEnter) == null ? void 0 : _a.call(dayProps, event);
            __onDayMouseEnter == null ? void 0 : __onDayMouseEnter(event, date);
          },
          onClick: event => {
            var _a;

            (_a = dayProps == null ? void 0 : dayProps.onClick) == null ? void 0 : _a.call(dayProps, event);
            __onDayClick == null ? void 0 : __onDayClick(event, date);
          },
          onMouseDown: event => {
            var _a;

            (_a = dayProps == null ? void 0 : dayProps.onMouseDown) == null ? void 0 : _a.call(dayProps, event);
            __preventFocus && event.preventDefault();
          },
          tabIndex: __preventFocus || !isDateInTabOrder ? -1 : 0
        })
      }, date.toString());
    });
    return /* @__PURE__ */jsxRuntimeExports.jsx("tr", { ...getStyles("monthRow"),
      children: cells
    }, rowIndex);
  });
  return /* @__PURE__ */jsxRuntimeExports.jsxs(Box, {
    component: "table",
    ...getStyles("month"),
    size,
    ref,
    ...others,
    children: [!hideWeekdays && /* @__PURE__ */jsxRuntimeExports.jsx("thead", { ...getStyles("monthThead"),
      children: /* @__PURE__ */jsxRuntimeExports.jsx(WeekdaysRow, {
        __staticSelector: __staticSelector || "Month",
        locale,
        firstDayOfWeek,
        weekdayFormat,
        size,
        classNames: resolvedClassNames,
        styles: resolvedStyles,
        unstyled
      })
    }), /* @__PURE__ */jsxRuntimeExports.jsx("tbody", { ...getStyles("monthTbody"),
      children: rows
    })]
  });
});
Month.classes = classes;
Month.displayName = "@mantine/dates/Month";
export { Month };